import React, { useEffect, useState, useContext } from "react";
import ColleguegroupeProfile from "./ColleguegroupeProfile";
import "./style.css";
import ReactTooltip from "react-tooltip";
import { Context } from "../../themeContext";
import Colleguegroupesmall from "./Colleguegroupesmall";
import { useTranslation, withTranslation } from "react-i18next";

//const ENDPOINT = "https://192.168.30.40:5004";
const token = localStorage.getItem("AccessToken");
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const BackendURL = window.BackendURLCmk;
var lien = window.location.href;
//console.log(lien);
const var22 = lien.split("/");

function Colleguegroupebox({ collegue }) {
  const [state, dispatch] = useContext(Context);
  const { t } = useTranslation("common");

  const [show, setShow] = useState(false);

  const hideModal = () => setShow(false);
  const showModal = () => setShow(true);

  const [showetat, setshowetat] = useState("");

  useEffect(() => {
    state?.socket?.on("FromAPI", (data) => {
      //console.log(data);
      if (data.compte !== compte) return;

      if (data.poste == collegue.poste) {
        if (data.EtatCommunication == "InUse") {
          setshowetat("use");
          var yo = "En com";
        }
        if (data.EtatCommunication == "Idle") {
          // console.log(data.poste);
          //console.log(data.EtatCommunication);
          setshowetat("idle");
          var yo = "";
        }
        if (data.EtatCommunication == "Ringing") {
          //console.log(data.poste);
          // console.log(data.EtatCommunication);
          // if (data.poste == poste) {
          //   document.getElementsByClassName("rtf")[0].classList.add("open");
          // }

          var ring = "Ringing";
          setshowetat(ring);

          // console.log(data.poste);

          // console.log(showetat, data.poste);
          var yo = "Sonnerie";
        }
      }
    });
    return () => {
      state?.socket?.off("FromAPI");
    };
  });

  return (
    <div className="max-w-7xl  px-2">
      <div className="holaa relative rounded-lg border border-gray-300 bg-white px-2 py-2 shadow-sm  space-x-3 hover:border-gray-400 dark:bg-gray-900 dark:text-white transition-al ">
        <div className="group flex justify-between items-center">
          {/* best practice of react tooltip    ********************     */}
          <div
            data-tip={collegue.nom}
            className="flex-1 flex items-center min-w-0 "
          >
            <ReactTooltip />
            <span className="flex-shrink-0 inline-block relative h-full dark:bg-gray-900">
              <div className="flex -space-x-4 z-0  overflow-hidden">
                {collegue.membre.map((post, i) => (
                  <Colleguegroupesmall collegue={post} key={i} />
                ))}
              </div>
            </span>
            <div className="ml-4 truncate">
              <p className="text-bg font-medium text-gray-900 truncate  dark:text-white transition-al ">
                {collegue.nom}
                {/* {props.collegue.nom} */}
              </p>
              <p className="text-lg text-gray-500 truncate flex">
                {collegue.numero}
              </p>

              <ColleguegroupeProfile
                show={show}
                close={hideModal}
                collegue={collegue}
                //  t={}
              />
            </div>
          </div>

          <div className=" ml-2  inline-block text-left">
            <button
              data-tip
              data-for="infogroupeTip"
              type="button"
              onClick={showModal}
              className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 dark:text-gray-200"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>

            <button
              data-tip
              disabled={String(collegue.numero) === poste}
              data-for="callTip"
              type="button"
              onClick={() =>
                dispatch({
                  type: "MAKE_CALL",
                  payload: {
                    type: "CALL",
                    number: collegue.numero,
                    image: "",
                    nom: collegue.nom,
                  },
                })
              }
              className={`
              ${
                String(collegue.poste) === poste
                  ? " cursor-not-allowed text-gray-200 pointer-events-none"
                  : "hover:text-green-600 focus:outline-none focus:ring-green-500 text-gray-500  "
              }
              dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium  bg-gray-100  focus:outline-none focus:ring-2 focus:ring-offset-2  m-1`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 dark:text-gray-200"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
            </button>
            <ReactTooltip
              id="callTip"
              place="bottom"
              effect="solid"
              data-background-color="yellow"
            >
              {t("Appeler")}
            </ReactTooltip>
            <ReactTooltip id="infogroupeTip" place="bottom" effect="solid">
              {t("group.profile")}
            </ReactTooltip>
          </div>
        </div>
      </div>
    </div>
  );
}
export default withTranslation("common")(Colleguegroupebox);
